// extracted by mini-css-extract-plugin
export var column = "detail-module--column--Tp3eq";
export var copy = "detail-module--copy--wIED9";
export var detailImages = "detail-module--detail-images--gmoYc";
export var detailImagesSingle = "detail-module--detail-images--single--4MwJu";
export var grid = "detail-module--grid--G8RSE";
export var gridHeader = "detail-module--grid-header--FhhDm";
export var item = "detail-module--item--ABZDb";
export var link = "detail-module--link--9vCOj";